import { jsx as t, jsxs as i, Fragment as z } from "react/jsx-runtime";
import s from "classnames";
import { forwardRef as c, useState as $, createContext as k, useContext as P, useRef as F, useEffect as M, Children as Q, isValidElement as X, cloneElement as Y } from "react";
import { calc as Z } from "@vanilla-extract/css-utils";
import { createPortal as B } from "react-dom";
import { ChevronUp as ee, ChevronDown as te } from "react-feather";
var Ke = "h0eyxr1", ae = "h0eyxr2 h0eyxr1";
const h = c(
  (e, a) => /* @__PURE__ */ t(
    "div",
    {
      ...e,
      ref: a,
      className: s(ae, e.className)
    }
  )
);
var re = "vwpiiw0";
const S = ({
  className: e,
  imgClassName: a,
  style: r,
  src: n,
  placeholder: l = !0,
  children: o,
  onClick: d
}) => {
  const [v, m] = $(n === !1);
  return /* @__PURE__ */ i("div", { className: e, style: r, onClick: d, children: [
    !l && v && n !== null && /* @__PURE__ */ t(h, {}),
    n !== null && /* @__PURE__ */ t(
      "img",
      {
        className: s(re, a),
        style: { display: v ? "none" : "block" },
        src: typeof n == "string" ? n : void 0,
        onLoad: () => m(!1)
      }
    ),
    n === null && o
  ] });
};
var p = { color: { primary: "var(--zdfy860)", secondary: "var(--zdfy861)", accent: "var(--zdfy862)", success: "var(--zdfy863)", error: "var(--zdfy864)" }, typography: { fontFamily: "var(--zdfy865)", fontSize: "var(--zdfy866)" }, sidebar: { openWidth: "var(--zdfy867)", closedWidth: "var(--zdfy868)" }, shape: { borderRadius: "var(--zdfy869)" }, oneUnit: "var(--zdfy86a)" };
const Me = (e, a) => `color-mix(in srgb, ${e} ${(a * 100).toFixed(2)}%, transparent)`, ne = (e, a, r = 0) => Z(e).multiply(a).add(`${r}px`).toString(), Qe = (e) => `(min-width: ${e}px)`, Xe = (e) => `(max-width: ${e}px)`;
var le = "edf3bn0";
const C = ({ className: e, src: a, size: r = 4, onClick: n }) => {
  const l = ne(p.oneUnit, r);
  return /* @__PURE__ */ t(
    S,
    {
      className: s(e, le),
      src: a,
      style: {
        width: l,
        height: l,
        borderRadius: l
      },
      onClick: n
    }
  );
};
var se = "_8bvdxh0", ie = { regular: "_8bvdxh1 _8bvdxh0", inverted: "_8bvdxh2 _8bvdxh0" }, I = "_8bvdxh3", oe = "_8bvdxh4";
const ce = c(
  ({
    variant: e = "regular",
    compact: a = !1,
    ...r
  }, n) => /* @__PURE__ */ t(
    "button",
    {
      ...r,
      ref: n,
      className: s(
        ie[e],
        a && I,
        r.className
      )
    }
  )
), y = c(
  ({
    compact: e,
    ...a
  }, r) => /* @__PURE__ */ t(
    h,
    {
      ...a,
      ref: r,
      className: s(
        se,
        e && I,
        oe,
        a.className
      )
    }
  )
);
var de = "w0uu6q0", ve = "_1dbjmn40";
const Ye = ({ children: e }) => /* @__PURE__ */ t("div", { className: ve, children: e });
var me = "lltce60";
const Ze = ({ children: e }) => /* @__PURE__ */ t("span", { className: me, children: e }), et = ({ children: e }) => /* @__PURE__ */ t("div", { className: de, children: e }), D = k(null);
D.displayName = "PortalContext";
const A = () => P(D);
var ue = "_1ayrinf0";
const tt = ({
  onClick: e,
  children: a
}) => {
  const r = A();
  return r === null ? null : B(
    /* @__PURE__ */ t("div", { className: ue, onClick: () => e == null ? void 0 : e(), children: /* @__PURE__ */ t("div", { onClick: (n) => n.stopPropagation(), children: a }) }),
    r
  );
};
var he = "_1uqi4qp0";
const ye = ({
  anchor: e,
  rootRef: a,
  className: r,
  children: n,
  onClick: l,
  onClose: o
}) => {
  const d = A(), v = F(null);
  if (M(() => {
    const _ = (u) => {
      a.current !== null && v.current !== null && u.target !== null && u.target instanceof window.Element && !a.current.contains(u.target) && !v.current.contains(u.target) && (o == null || o());
    };
    return document.addEventListener("mousedown", _), () => {
      document.removeEventListener("mousedown", _);
    };
  }, [o, a]), d === null || a.current === null)
    return null;
  const m = a.current.getBoundingClientRect(), K = {
    left: m.left,
    right: document.body.clientWidth - m.right
  };
  return B(
    /* @__PURE__ */ t(
      "div",
      {
        ref: v,
        className: s(he, r),
        style: {
          minWidth: m.width,
          top: m.bottom,
          [e]: K[e]
        },
        onClick: l,
        children: n
      }
    ),
    d
  );
};
var pe = "_2nf2sd0", Se = "_2nf2sd1", Ne = "_2nf2sd2", fe = "_2nf2sd3";
const at = ({
  id: e,
  label: a,
  children: r,
  childrenClassName: n
}) => /* @__PURE__ */ i("div", { className: pe, children: [
  /* @__PURE__ */ t("label", { htmlFor: e, children: a }),
  /* @__PURE__ */ t("div", { className: s([Se, n]), children: Q.map(r, (l) => X(l) ? Y(l, {
    className: s([
      l.props.className,
      Ne,
      fe
    ])
  }) : l) })
] });
var b = { regular: "_6hv57f1 _6hv57f0", inverted: "_6hv57f2 _6hv57f0" }, _e = "_6hv57f3 h0eyxr1 _6hv57f1 _6hv57f0";
const g = ({
  children: e,
  variant: a = "regular",
  ...r
}) => {
  if ("as" in r && r.as !== void 0) {
    const { as: n, className: l, ...o } = r;
    return /* @__PURE__ */ t(
      n,
      {
        ...o,
        className: s(b[a], l),
        children: e
      }
    );
  }
  return /* @__PURE__ */ t(
    "button",
    {
      ...r,
      className: s(b[a], r.className),
      children: e
    }
  );
}, rt = c(
  (e, a) => /* @__PURE__ */ t(
    "div",
    {
      ref: a,
      ...e,
      className: s(_e, e.className)
    }
  )
);
var be = "_1vujhe71", ge = "_1vujhe72";
const nt = c(
  (e, a) => /* @__PURE__ */ t(
    "div",
    {
      ...e,
      ref: a,
      className: s(ge, e.className),
      children: /* @__PURE__ */ t("div", { className: be })
    }
  )
);
var xe = "dig8qe0";
const W = c(
  ({ className: e, ...a }, r) => /* @__PURE__ */ t(
    "input",
    {
      ...a,
      ref: r,
      className: s([xe, e])
    }
  )
);
W.displayName = "Input";
var we = "y9sk9u0";
const lt = c(
  (e, a) => {
    const { id: r, label: n, ...l } = e;
    return /* @__PURE__ */ i("div", { className: we, children: [
      /* @__PURE__ */ t("label", { htmlFor: r, children: n }),
      /* @__PURE__ */ t(W, { ...l, id: r, ref: a })
    ] });
  }
);
var N = "_1pa6eiz0", j = "_1pa6eiz1", q = "_1pa6eiz2", E = "_1pa6eiz3", L = "_1pa6eiz4", R = "_1pa6eiz5", ze = "_1pa6eiz6", f = "_1pa6eiz7", U = "_1pa6eiz8", G = "_1pa6eiz9", $e = "_1pa6eiza", O = "_1pa6eizb", x = "_1pa6eizc", ke = "_1pa6eizd";
const st = ({
  previewUrl: e,
  name: a,
  description: r,
  children: n,
  author: l,
  avatarUrl: o,
  onPreviewClick: d
}) => /* @__PURE__ */ t("div", { className: N, children: /* @__PURE__ */ i("div", { className: s([U, f]), children: [
  /* @__PURE__ */ t(
    S,
    {
      src: e,
      className: s(
        G,
        d !== void 0 && $e
      ),
      onClick: d,
      children: /* @__PURE__ */ t("div", { className: ze, children: "Preview missing" })
    }
  ),
  /* @__PURE__ */ i("div", { className: j, children: [
    /* @__PURE__ */ t("span", { className: q, children: a }),
    /* @__PURE__ */ t("span", { className: E, children: r }),
    /* @__PURE__ */ i("span", { className: L, children: [
      /* @__PURE__ */ i("span", { className: O, children: [
        /* @__PURE__ */ t(C, { src: o, size: 4 }),
        "by ",
        l
      ] }),
      n !== void 0 && /* @__PURE__ */ t("div", { className: R, children: n })
    ] })
  ] })
] }) }), it = c((e, a) => /* @__PURE__ */ t("div", { className: N, ref: a, children: /* @__PURE__ */ t("div", { className: f }) })), ot = c((e, a) => /* @__PURE__ */ t("div", { className: N, ref: a, children: /* @__PURE__ */ i("div", { className: s([U, f]), children: [
  /* @__PURE__ */ t(S, { src: !1, className: G }),
  /* @__PURE__ */ i("div", { className: j, children: [
    /* @__PURE__ */ t(
      h,
      {
        className: s([q, x])
      }
    ),
    /* @__PURE__ */ t(
      h,
      {
        className: s([E, x])
      }
    ),
    /* @__PURE__ */ i("span", { className: L, children: [
      /* @__PURE__ */ t("span", { className: O, children: /* @__PURE__ */ t(C, { src: !1, size: 4, className: ke }) }),
      /* @__PURE__ */ i("div", { className: R, children: [
        /* @__PURE__ */ t(y, {}),
        /* @__PURE__ */ t(y, {}),
        /* @__PURE__ */ t(y, {})
      ] })
    ] })
  ] })
] }) }));
var Pe = "_3up9x30", Fe = "_3up9x31", Be = "_3up9x32 _3up9x30", Ce = "_3up9x33 _3up9x31 h0eyxr1";
const T = c(
  ({ className: e, ...a }, r) => /* @__PURE__ */ t("div", { className: s(Pe, e), children: /* @__PURE__ */ t("select", { ...a, ref: r, className: Fe }) })
);
T.displayName = "Select";
const H = ({ className: e }) => /* @__PURE__ */ t("div", { className: s(Be, e), children: /* @__PURE__ */ t("div", { className: Ce }) });
H.displayName = "SelectSkeleton";
var V = "n51h0e0", Ie = "n51h0e1";
const De = c(
  (e, a) => {
    const { id: r, label: n, ...l } = e;
    return /* @__PURE__ */ i("div", { className: V, children: [
      /* @__PURE__ */ t("label", { htmlFor: r, children: n }),
      /* @__PURE__ */ t(T, { ...l, id: r, ref: a })
    ] });
  }
);
De.displayName = "SelectField";
const ct = ({ label: e }) => /* @__PURE__ */ i("div", { className: V, children: [
  /* @__PURE__ */ t("span", { className: Ie, children: e }),
  /* @__PURE__ */ t(H, {})
] });
var Ae = "_1ygqwsg0";
const dt = ({ orientation: e = "horizontal" }) => /* @__PURE__ */ t(
  "div",
  {
    className: Ae,
    style: { [e === "horizontal" ? "width" : "height"]: "unset" }
  }
);
var We = "k7q3gi0";
const J = k({
  open: !1
}), vt = (e) => /* @__PURE__ */ t(
  "aside",
  {
    className: We,
    style: {
      width: e.open ? p.sidebar.openWidth : p.sidebar.closedWidth
    },
    children: /* @__PURE__ */ t(J.Provider, { value: { open: e.open }, children: e.children })
  }
);
var w = "epxwza0";
const mt = ({
  icon: e,
  children: a,
  ...r
}) => {
  const { open: n } = P(J), l = /* @__PURE__ */ i(z, { children: [
    e,
    a
  ] });
  if ("as" in r && r.as !== void 0) {
    if (n) {
      const { as: o, ...d } = r;
      return /* @__PURE__ */ t(o, { ...d, className: w, children: l });
    }
    return /* @__PURE__ */ t(g, { ...r, children: e });
  }
  return n ? /* @__PURE__ */ t("button", { className: w, ...r, children: l }) : /* @__PURE__ */ t(g, { children: e });
};
var je = "_1p6m9340", qe = "_1p6m9341", Ee = "_1p6m9342";
const ut = ({ children: e }) => {
  const [a, r] = $(!1), n = F(null);
  return e === void 0 || Array.isArray(e) && e.length === 0 ? null : /* @__PURE__ */ t(
    "div",
    {
      ref: n,
      className: s(je, a && qe),
      children: Array.isArray(e) ? /* @__PURE__ */ i(z, { children: [
        e[0],
        e.length > 1 && /* @__PURE__ */ t(
          ce,
          {
            "data-testid": "dropdown",
            onClick: () => r(!a),
            children: a ? /* @__PURE__ */ t(ee, {}) : /* @__PURE__ */ t(te, {})
          }
        ),
        a && /* @__PURE__ */ t("div", { onClick: () => r(!1), children: /* @__PURE__ */ t(
          ye,
          {
            anchor: "left",
            rootRef: n,
            onClose: () => r(!1),
            children: /* @__PURE__ */ t("ul", { className: Ee, children: e.slice(1).map((l, o) => /* @__PURE__ */ t("li", { children: l }, `split-button-child-${o}`)) })
          }
        ) })
      ] }) : e
    }
  );
};
var Le = "o4kbbx0";
const Re = c(
  (e, a) => /* @__PURE__ */ t(
    "input",
    {
      type: "checkbox",
      ...e,
      ref: a,
      className: s(Le, e.className)
    }
  )
);
var Ue = "cmptaa0";
const ht = c(
  (e, a) => {
    const { id: r, label: n, ...l } = e;
    return /* @__PURE__ */ i("div", { className: Ue, children: [
      /* @__PURE__ */ t("label", { htmlFor: r, children: n }),
      /* @__PURE__ */ t(Re, { ...l, id: r, ref: a })
    ] });
  }
);
var yt = "_1jtswr11";
export {
  C as Avatar,
  ce as Button,
  y as ButtonSkeleton,
  et as Dialog,
  Ye as DialogActions,
  Ze as DialogTitle,
  ye as DropdownContainer,
  h as GradientPlaceholder,
  at as GroupField,
  g as IconButton,
  rt as IconButtonSkeleton,
  S as Image,
  nt as IndeterminatePlaceholder,
  W as Input,
  lt as InputField,
  tt as Overlay,
  D as PortalContext,
  st as PresetCard,
  it as PresetCardDummy,
  ot as PresetCardSkeleton,
  T as Select,
  De as SelectField,
  ct as SelectFieldSkeleton,
  H as SelectSkeleton,
  dt as Separator,
  vt as Sidebar,
  mt as SidebarButton,
  ut as SplitButton,
  Re as Switch,
  ht as SwitchField,
  ie as buttonStyle,
  Xe as containerDown,
  Qe as containerUp,
  Me as mixInTransparency,
  Ke as skeletonAnimation,
  ne as spacing,
  yt as spinnerAnimation,
  p as theme,
  A as usePortalContainer
};
//# sourceMappingURL=index.js.map
